import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import style from "./ErrorView.style";
import { ErrorView } from "./ErrorView";

export default compose(withStyles(style))(ErrorView);
